<template>
  <div class="text-center">
    <v-progress-circular
      :rotate="360"
      :size="100"
      :width="15"
      :value="value"
      :color="myColor"
    >
      {{ value }}%
    </v-progress-circular>
  </div>
</template>

<script>
  export default {
    props: ["emitter", "ikey", "getData", "putData"],
    data () {
      return {
        value: 0,
      }
    },
    beforeDestroy () {
 
    },
    computed:{
        myColor() {
            if(this.value == 100){
                return "green"
            }else{
                return "primary";
            }
        }
    }
  }
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}
</style>